import { PendingTemplatesComponent } from "@/components/pending";
import { ProjectPageHeader } from "@/components/project/project-page-header";
import { ProjectPage } from "@/components/project/project-page";
import { EnvironmentSelector } from "@/components/project/environment-selector";
import { QueryBoundary } from "@/components/query-boundary";
import { TemplateTable } from "@/components/template/template-table";
import { orpc } from "@/lib/orpc";
import { TemplateCreateWizard } from "@/components/template/template-create-wizard";
import { TemplateGenerator } from "@/components/template/template-generator";
import { templateSearchSchema } from "@/components/template/template-search";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/")({
  component: IndexProjectTemplates,
  validateSearch: templateSearchSchema,
});

function IndexProjectTemplates() {
  const { useParams, useSearch, useNavigate } = Route;
  const params = useParams();
  const { env } = useSearch();
  const navigate = useNavigate();

  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({
      input: params,
      ...{
        select: (data) => ({ environments: data.environments, id: data.id }),
      },
    }),
  );

  return (
    <ProjectPage>
      <ProjectPageHeader
        title="Templates"
        description="Craft your messages. Make every interaction feel personal."
        actions={
          <div className="flex flex-wrap gap-2">
            <TemplateGenerator projectId={project.id} />
            <TemplateCreateWizard />
          </div>
        }
      />
      <QueryBoundary suspenseFallback={<PendingTemplatesComponent />}>
        <TemplateTable
          environmentSelector={
            <EnvironmentSelector
              currentEnv={env || "all"}
              environments={project.environments}
              setEnvironment={(value) =>
                navigate({ search: (previous) => ({ ...previous, env: value }), replace: true })
              }
            />
          }
        />
      </QueryBoundary>
    </ProjectPage>
  );
}
